import { render, staticRenderFns } from "./ManufacturerBusinessPerson.vue?vue&type=template&id=5bd7d0f1&scoped=true&"
import script from "./ManufacturerBusinessPerson.vue?vue&type=script&lang=js&"
export * from "./ManufacturerBusinessPerson.vue?vue&type=script&lang=js&"
import style0 from "./ManufacturerBusinessPerson.vue?vue&type=style&index=0&id=5bd7d0f1&scoped=true&lang=css&"
import style1 from "./ManufacturerBusinessPerson.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd7d0f1",
  null
  
)

export default component.exports